var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.allFinished)?_c('dot-loader',{staticClass:"loader"}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allFinished),expression:"allFinished"}]},[_c('date-selection-container',[_c('MissingDeals')],1),_c('deal-table',{on:{"loadingFinished":function($event){_vm.tableFinished = true}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }